import { Suspense } from "react";
import { Column } from "@hightouch/htui";
import { ErrorBoundary } from "react-error-boundary";

import {
  NewPage,
  PageCardContent,
  PageCardHeader,
} from "src/components/layout/new-page";
import { useEntitlements } from "src/hooks/use-entitlement";
import { Header } from "src/pages/home/components/header";
import { ResourceCards } from "src/pages/home/components/resource-cards";
import { RecentlyViewed } from "src/pages/home/components/recently-viewed";
import { MAX_WIDTH } from "src/pages/home/constants";
import { SkeletonItem } from "src/components/skeletons";
import { lazyNamed } from "src/utils/lazy-named";
import { AudienceSummary } from "./audience-summary";

const Metrics = lazyNamed(() => import("./metrics"), "Metrics");

export const MarketingHome = ({
  onToggleView,
}: {
  onToggleView: () => void;
}) => {
  const { data: entitlementsData } = useEntitlements(false);
  const appEnableJourneys = entitlementsData.entitlements.journeys;

  const header = (
    <Header onToggleView={onToggleView} view="marketing">
      <ResourceCards
        view="marketing"
        resources={
          appEnableJourneys
            ? ["audience", "journey", "destination"]
            : ["audience", "destination", "sync"]
        }
      />
    </Header>
  );

  const content = (
    <>
      <RecentlyViewed view="marketing" />
      <Column gap={4}>
        <AudienceSummary />
        <ErrorBoundary fallback={null}>
          <Suspense
            fallback={
              <SkeletonItem borderRadius="lg" minHeight="300px" width="100%" />
            }
          >
            <Metrics />
          </Suspense>
        </ErrorBoundary>
      </Column>
    </>
  );

  return (
    <NewPage title="Home">
      <PageCardHeader removeBoxShadow>{header}</PageCardHeader>
      <PageCardContent hasGradient variant="light">
        <Column align="center" flex={1}>
          <Column gap={6} maxW={MAX_WIDTH} w="100%">
            {content}
          </Column>
        </Column>
      </PageCardContent>
    </NewPage>
  );
};
